module.exports = __webpack_public_path__ + "static/img/img_reason3.6c3d803.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/mobile_barocare/img_reason3.png
// module id = m7rm
// module chunks = 0